import React, { useContext } from 'react';
import cn from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useEditorContext } from '../../Editor/Context';
import { useForceUpdate } from '../../../hooks/useForceUpdate';
import CharacterCount from '../items/CharacterCount';
import Reaction from '../buttons/Reaction';
import { ThemeSurface } from '@wix/da-react-context/pkg/constants';
import { ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import s from './PollMenu.scss';
const PollMenu = ({ noAtomics = false })=>{
    const editor = useEditorContext();
    const forceUpdate = useForceUpdate();
    const isMobile = useContext(MobileContext);
    // Listen to editor as its not react so we need to react here
    editor === null || editor === void 0 ? void 0 : editor.on('transaction', ()=>{
        forceUpdate();
    });
    if (!editor) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        themeSurface: ThemeSurface.TERTIARY,
        className: cn(s['root'])
    }, /*#__PURE__*/ React.createElement(CharacterCount, {
        editor: editor
    }), !noAtomics && !isMobile && /*#__PURE__*/ React.createElement(Reaction, {
        editor: editor
    }));
};
PollMenu.displayName = 'PollMenu';
export default PollMenu;

//# sourceMappingURL=PollMenu.js.map